// extracted by mini-css-extract-plugin
export default {"subscription-support":"SubscriptionSupport_subscription-support__my+cZ","subscription-support__title":"SubscriptionSupport_subscription-support__title__GyOWY"};